export const transfersSection = '/transfers';

export const transfersPath = transfersSection;
export const createTreansferPath = '/create-transfer';

export const transferDetailPath = (id: string) => `${transfersPath}/${id}`;
export const transferDetailRoute = `${transfersPath}/:id`;

export const transferCancelPath = (id: string) => `${transfersPath}/${id}/cancel`;
export const transferCancelRoute = `${transfersPath}/:id/cancel`;
